// F-RPT-N42 — the cost-basis lookup the backend uses (finance.BasisOn),
// ported so screens can decide per date without a round trip: which basis a
// given expense date is on, and therefore whether a stock category may be
// filed by hand on that day.
import type { CogsBasis, CogsBasisPeriod } from '@/types'

/** The basis in force on `date` (YYYY-MM-DD). No rows, or none yet effective, means at_sale. */
export function basisOn(periods: ReadonlyArray<CogsBasisPeriod> | undefined, date: string): CogsBasis {
  let best: CogsBasisPeriod | undefined
  for (const p of periods ?? []) {
    if (p.effective_from <= date && (!best || p.effective_from > best.effective_from)) best = p
  }
  return best?.basis ?? 'at_sale'
}

/**
 * A manual expense may use a stock category only on a purchases-basis day,
 * where the row is that day's cost of goods (mirrors finance.ManualStockEntryAllowed).
 */
export function manualStockEntryAllowed(periods: ReadonlyArray<CogsBasisPeriod> | undefined, date: string): boolean {
  return basisOn(periods, date) === 'purchases'
}

/** The calendar date of a datetime-local value ("2026-10-14T13:05" → "2026-10-14"), or '' . */
export function dateOfLocal(value: string | undefined | null): string {
  const s = (value ?? '').trim()
  return /^\d{4}-\d{2}-\d{2}/.test(s) ? s.slice(0, 10) : ''
}
